/** Stavy pre min ideal */
export enum MinIdealStates {

  inIdeal = 'inIdeal',
  outIdeal = 'outIdeal'

}